import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as Global from 'src/app/global';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  Global = Global;
  resetPwdForm: FormGroup;
  passwordForm: FormGroup;
  otpSent: boolean = false;
  otpValidated: boolean = false;
  queryParams: any = null;
  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.queryParams = this.route.snapshot.queryParamMap.get('tab') || '';

    this.resetPwdForm = formBuilder.group({
      email: [
        null,
        Validators.compose([Validators.required, Validators.email]),
      ],
    });

    this.passwordForm = formBuilder.group({
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(
            '(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=])(?=.{8,}).*$'
          ),
        ]),
      ],
      password_confirmation: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(
            '(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=])(?=.{8,}).*$'
          ),
        ]),
      ],
    });

    // this.resetPwdForm.patchValue({
    //   "email": "john.doe@yopmail.com",
    // })
  }

  ngOnInit(): void {}

  sendOtp(event: any) {
    this.resetPwdForm.markAllAsTouched();
    setTimeout(() => {
      Global.scrollToQuery('.form-control.is-invalid');
    }, 100);

    if (this.resetPwdForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.authService
        .resetPwdSendOtp({
          email: this.resetPwdForm.value.email ?? null,
          for: this.queryParams??'coach',
        })
        .subscribe(
          async (res) => {
            if (res.status == 'success') {
              this.otpSent = true;
              this.toastr.success(res.message);
            } else if (res.status == 'val_error') {
              this.toastr.error(Global.getValidationMessage(res.errors ?? []));
            } else {
              this.toastr.error(res.message);
            }

            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
          (err) => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }

  otpVerificationAction(action: any) {
    if (action == true) {
      this.otpValidated = true;
      this.toastr.success(
        'OTP successfully verified. Please change your password'
      );
    } else {
      this.toastr.error(
        'OTP Verification Failed. Please try again to continue'
      );
    }
  }

  changePassword(event: any) {
    this.passwordForm.markAllAsTouched();
    setTimeout(() => {
      Global.scrollToQuery('.form-control.is-invalid');
    }, 100);

    if (this.passwordForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.authService
        .resetPassword({
          email: this.resetPwdForm.value.email ?? null,
          password: this.passwordForm.value.password ?? null,
          password_confirmation:
            this.passwordForm.value.password_confirmation ?? null,
            for: this.queryParams??'coach',
          })
        .subscribe(
          async (res) => {
            if (res.status == 'success') {
              this.router.navigate(['/login'], {
                queryParams: { tab: this.queryParams },
              });
              this.toastr.success(
                'Password changed successfully. Signin with new password to access your account'
              );
            } else if (res.status == 'val_error') {
              this.toastr.error(Global.getValidationMessage(res.errors ?? []));
            } else {
              this.toastr.error(res.message);
            }

            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
          (err) => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }
}
